import { useRouter } from 'expo-router';
import GetHigherAdvance from 'features/advance/screens/advanceStatusScreens/AdvanceApproved/components/GetHigherAdvance/GetHigherAdvance';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useDirectDepositManagementFlow from 'shared/hooks/pinwheel/useDirectDepositManagementFlow/useDirectDepositManagementFlow';
import usePinwheel from 'shared/hooks/pinwheel/usePinwheel/usePinwheel';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';

const noop = () => {};

const VaD0EligibleApprovedCongrats = ({
  maxApprovedAmount,
}: {
  maxApprovedAmount: string;
}) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'getHigherAdvanceStrings',
  });

  const { initiatePinwheel, isPinwheelLoading } = usePinwheel();

  const { shouldLaunchPinwheelSDK, handleDdManagementLinkTokenFailure } =
    useDirectDepositManagementFlow();

  const dismissToTab = useDismissToRootTab();

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };

  const goToNextAdvanceScreen = ({ success }) => {
    if (success) {
      router.replace({
        pathname: '/varo-advance/new',
        params: { skipDdPrompt: 'true' },
      });
    } else {
      noop();
    }
  };

  const handleDirectDeposit = () => {
    const outcomeCallback = shouldLaunchPinwheelSDK
      ? goToNextAdvanceScreen
      : goHome;

    initiatePinwheel({
      onOutcome: outcomeCallback,
      ...(shouldLaunchPinwheelSDK && {
        onLinkTokenError: handleDdManagementLinkTokenFailure,
      }),
    });
  };

  return (
    <ProductIntroScreen
      headlineText={translatedText('title', {
        qualifiedAmount: maxApprovedAmount,
      })}
      headlineTextStyle="expressive"
      primaryButton={{
        label: translatedText('buttons.directDeposit'),
        onPress: handleDirectDeposit,
        analyticsId: 'directDeposit',
        customAttributes: {
          cta: 'Set up direct deposit',
        },
        isDisabled: isPinwheelLoading,
        isLoading: isPinwheelLoading,
      }}
      secondaryButton={{
        label: translatedText('buttons.continue'),
        onPress: () => {
          router.replace({
            pathname: '/varo-advance/new',
            params: { skipDdPrompt: 'true' },
          });
        },
        isDisabled: isPinwheelLoading,
        isLoading: isPinwheelLoading,
        analyticsId: 'continueWithoutDD',
        customAttributes: {
          cta: 'Continue without direct deposit',
        },
      }}
      bodyContent={<GetHigherAdvance maxApprovedAmount={maxApprovedAmount} />}
      visual="ADVANCE_A"
      topPadding={80}
    />
  );
};

export default VaD0EligibleApprovedCongrats;
